import dayjs, { Dayjs, ConfigType, OpUnitType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import isoWeek from 'dayjs/plugin/isoWeek';

import 'dayjs/locale/en.js';
import 'dayjs/locale/es.js';

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.extend(isoWeek);

export type TimeInstance = Dayjs;
export type TimeInput = ConfigType;
export type TimeStep = OpUnitType;

export { dayjs };
